import type { ReactNode, CSSProperties } from 'react';

// Solid dark panel matching BookingSummaryCard — used to lift the calendar,
// slots, and form off the page so text stays legible over the static still.
export function BookingPanel({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <div
      style={{
        background: 'var(--bg-elevated)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-2xl)',
        padding: 24,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
